module.exports = __webpack_public_path__ + "img/price.3aba258.svg";